/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const StockCountersContext = createContext({
  fetchStockCounters: () => {}
})

export default StockCountersContext
